<template>
<div v-if="data.details.status_type && data.details.status_type === 'message'">
    <div class="row successed" v-if="data.details.type.toLowerCase() == 'successful'">
        <p class="payment-success">Payment Successful</p>

        <h3 class="text-center gray text-bold h3 my-5" v-html="data.details.message" style="margin-top:3rem;"></h3>
        <button @click.prevent="continueToMerchant" class="submit modal-trigger modal-close">{{ client_info.merchant.return_text || 'Done'}}</button>
    </div>
</div>
<div v-else>
    <div class="row successed" v-if="data.details.type.toLowerCase() == 'successful'">
        <img src="/mtn/assets/confirmation.png" alt="" class="confirmimage" />
        
        <p class="payment-success" v-if="$store.state.payload.request_type.toLowerCase() === 'collect'" >Payment Successful</p>
        <p class="payment-success" v-else-if="$store.state.payload.request_type.toLowerCase() === 'buy airtime' || $store.state.payload.request_type.toLowerCase() === 'buy_airtime'" >Airtime Purchase Successful</p>
        <p class="payment-success" v-else> Transaction Payment</p>

        <p class="pay-date">{{date}}</p>
        <!-- <p class="payment-message">You have made a successful payment <br>of <strong>N{{ payment_data.provider_response.transaction_final_amount/100}}</strong></p> -->
        <p class="payment-message">You have made a successful payment <br>of <strong>N{{ $store.state.payload.transaction.amount/100}}</strong></p>

        <div class="transaction-det">
            <p class="tran-id-hd">Transaction ID</p>
            <p class="transaction-code">
                <!-- {{ payment_data.provider_response.reference }} -->
                {{ $store.state.transRef }}
            </p>
            
            <!-- <div  v-if="$store.state.mPGSCardUsed && Object.keys($store.state.mPGSCardUsed).$store.state.mPGSCardUsed.scheme"  class="debit-from"> -->
            <div  v-if="$store.state.mPGSCardUsed && Object.keys($store.state.mPGSCardUsed).includes('scheme')"  class="debit-from">
                <p class="">Debited from</p>
                <div class="card-charge">
                    <p v-if="$store.state.mPGSCardUsed.scheme" class="card-type-charge">{{ getCard($store.state.mPGSCardUsed.scheme) }}</p>
                    <p v-if="$store.state.mPGSCardUsed.number !== undefined"  class="card-type-charge">{{ $formatCard($store.state.mPGSCardUsed.number.toUpperCase()) }}</p>
                </div>
            </div>
        </div>

        <button @click.prevent="continueToMerchant" class="submit modal-trigger modal-close">{{ client_info.merchant.return_text || 'Done'}}</button>
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'status',
    props: {
        data: Object,
        appColor: String,
        message: String,
        button_color: Object,
        client_info: Object,
    },
    data() {
        return {
            paymentProvider: '',
            date: this.$todaysDate(),
            payment_data: {},
            paymentMethod: '',
        }
    },
    
    created() {
        // var res = JSON.parse(window.raw) //JSON.parse(localStorage.raw);
        // this.date = this.$todaysDate()
        // console.log(this.$store.state);
        // console.log(window.raw);

        let data = this.data.details;
        this.payment_data = this.data.details.data

        if (data.data)
            delete data.data.client_info;

        let paymentMethod = this.$store.state.paymentMethod.toLowerCase();
        this.paymentMethod = paymentMethod;
        // this.paymentProvider =  this.$store.state.mPGSCardUsed ? this.$store.state.paymentProvider.toLowerCase() : null;
        // let paymentMethodProvider = this.$store.state.paymentMethodProvider;
        let autoClose = this.$parent.hasAutoClose(paymentMethod, data.type)
        if (autoClose && autoClose.status) {
            setTimeout(() => {
                this.$parent.continueToMerchant({
                    data: data.data,
                    message: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'Service will be provided upon confirmation of payment.'  : data.message,
                    // status: data.type,
                    status: (this.data.details.status_type && this.data.details.status_type === 'message')  ? 'PendingFulfilment' : data.type,
                });
            }, autoClose.timeout * 1000)
            return;
        }
    },
    methods: {
        getCard(str){
            return str && str.toLowerCase() === 'mastercard' ? `${str.charAt(0)}${str.slice(1).toLowerCase()}` : `${str.charAt(0)}${str.slice(1).toLowerCase()} Card`;
        },
        tryAgain() {
            this.$router.push('/v2/mtn/popup');
            let ref = Date.now() + (Math.floor(Math.random() * 1000)).toString()
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.loading = false;
        },

        continueToMerchant() {
            if (window.raw) {
                var res = JSON.parse(window.raw);
                delete res.client_info;
                delete res.paymentoptions;
                this.$parent.continueToMerchant({
                    message: (this.data.details.status_type && this.data.details.status_type === 'message') ? 'Service will be provided upon confirmation of payment.'  : res.message,
                    // status: res.status || res.status,
                    status: (this.data.details.status_type && this.data.details.status_type === 'message')  ? 'PendingFulfilment' : res.status || res.status,
                    data: res.data,
                });
            }
        },
    }
};
</script>
